import { Select } from "@mantine/core";
import type { Person } from "../../../../utils/backend-types";

interface CompanyCellProps {
  companyId: number | null;
  companies?: Array<Person>;
  value: number | null;
  onChange: (companyId: number) => void;
}

/**
 * Dropdown cell for selecting a company (Person) inside a MantineReactTable
 * row. Displays the company name in a `Select`; when `companies` is not yet
 * loaded, falls back to rendering the raw id so a table row still has
 * something sensible to show.
 */
function CompanyCell({
  companies,
  companyId,
  value,
  onChange
}: CompanyCellProps) {
  if (!companies) {
    return <span>{value}</span>;
  }

  const data = companies.map((company) => ({
    value: String(company.id),
    label: company.name
  }));

  return (
    <div className="company-cell">
      <Select
        aria-label="Unternehmen"
        data={data}
        placeholder="Unternehmen auswählen"
        value={companyId !== null ? String(companyId) : null}
        onChange={(nextValue) => {
          if (nextValue !== null) {
            onChange(parseInt(nextValue, 10));
          }
        }}
      />
    </div>
  );
}

export { CompanyCell, type CompanyCellProps };
